Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.PublicationsSessionFilterView extends Backbone.View

  template: JST["backbone/templates/monitoring/filters/publications_session_filter"]

  events:
    'click #query-filters-tabs #content-filters': 'showContentsFilter'
    'click #query-filters-tabs #post-filters': 'showPostsFilter'

  defaultSectionTabsClassesByActiveSection: {
    contents: { contents: ['active'], posts: [] },
    posts: { contents: ['disabled'], posts: ['active'] }
  }

  defaultFiltersClassesByActiveSection: {
    contents: { contents: [], posts: ['hidden']},
    posts: { contents: ['hidden'], posts: [] }
  }

  initialize: (@options = {}) ->
    @activeSection = @options.activeSection
    @selectedProvider = @options.selectedProvider
    topics = @options.topics
    sortedAvailableChannelsByProvider = @options.sortedAvailableChannelsByProvider

    contentsSection = @options.contentsSection
    postsSection = @options.postsSection

    @contentsFilterView = new Monitoring.Views.SocialContents.Filters.PublicationsSession.ContentsFilterView({
      options: contentsSection,
      filterContainerView: @,
      selectedProvider: @selectedProvider,
      topics: topics,
      sortedAvailableChannelsByProvider: sortedAvailableChannelsByProvider
    })
    @postsFilterView = new Monitoring.Views.SocialContents.Filters.PublicationsSession.PostsFilterView({
      options: postsSection,
      filterContainerView: @,
      selectedProvider: @selectedProvider,
      sortedAvailableChannelsByProvider: sortedAvailableChannelsByProvider
    })
    @postsFilterSectionRendered = false
    @contentsFilterSectionRendered = false

  render: ->
    @$el.html(@template(
      contentsSectionClasses: @defaultContentsSectionClasses()
      postsSectionClasses: @defaultPostsSectionClasses()
    ))
    if @activeSection == 'posts'
      @renderPostsFilterSection()
    else
      @renderBothFilterSections()

    @

  renderPostsFilterSection: ->
    @postsFilterView.render()
    @$el.find('.post-filters').append(@postsFilterView.el)
    @postsFilterSectionRendered = true

  renderBothFilterSections: ->
    @renderPostsFilterSection()
    @contentsFilterView.render()
    @$el.find('.content-filters').append(@contentsFilterView.el)
    @contentsFilterSectionRendered = true

  defaultContentsSectionClasses: ->
    {
      tab: @defaultSectionTabsClassesByActiveSection[@activeSection].contents.join(' '),
      filter: @defaultFiltersClassesByActiveSection[@activeSection].contents.join(' ')
    }

  defaultPostsSectionClasses: ->
    {
      tab: @defaultSectionTabsClassesByActiveSection[@activeSection].posts.join(' '),
      filter: @defaultFiltersClassesByActiveSection[@activeSection].posts.join(' ')
    }

  showContentsFilter: =>
    @$el.find('#post-filters').removeClass('active')
    @$el.find('.post-filters').addClass('hidden')
    @$el.find('#content-filters').addClass('active')
    @$el.find('.content-filters').removeClass('hidden')

    @trigger('showContentsSection')

  showPostsFilter: =>
    @$el.find('#content-filters').removeClass('active')
    @$el.find('.content-filters').addClass('hidden')
    @$el.find('#post-filters').addClass('active')
    @$el.find('.post-filters').removeClass('hidden')

    @trigger('showPostsSection')

  # Disable comment selection when post selection has change
  disableContentsTab: =>
    @$el.find('#content-filters').addClass('disabled')

  filtersContainer: =>
    @$el.find('#filters-container')

  destroy: ->
    @contentsFilterView.destroy() if @contentsFilterSectionRendered
    @postsFilterView.destroy()    if @postsFilterSectionRendered
    @remove()
    false
